import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import StorePicker from './StorePicker';

// App pages
import App from './App';
import Admin from './Admin';
import NotFound from './NotFound';
import Checkout from './Checkout';

const Router = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path="/" component={StorePicker} />
      <Route exact path="/store/:storeId/admin" component={Admin}/>
      <Route exact path="/store/:storeId/checkout" component={Checkout}/>
      <Route path="/store/:storeId" component={App} />
      <Route component={NotFound} />
    </Switch>
  </BrowserRouter>
);

export default Router;



// WEBPACK FOOTER //
// ./src/components/Router.js